
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff","clip-path":"url(#clip0_24974_2448)"}},[_c('path',{attrs:{"d":"M5.534.671a5.349 5.349 0 110 10.657.523.523 0 01.09-1.041 4.303 4.303 0 100-8.574.523.523 0 01-.09-1.042zM4.434 1.404a.523.523 0 01-.253.695 4.297 4.297 0 00-.649.376.523.523 0 01-.6-.856c.253-.178.523-.335.807-.467a.523.523 0 01.695.252zM2.347 2.804a.523.523 0 01.128.728c-.144.204-.27.421-.376.65a.523.523 0 11-.947-.443c.132-.284.289-.554.467-.807a.523.523 0 01.728-.128zM1.237 5.058c.288.025.501.278.476.566a4.364 4.364 0 000 .752.523.523 0 01-1.042.09 5.411 5.411 0 010-.932.523.523 0 01.566-.476zM1.404 7.566a.523.523 0 01.695.253c.106.228.232.445.376.649a.523.523 0 01-.856.6 5.343 5.343 0 01-.467-.807.523.523 0 01.252-.695zM2.804 9.653a.523.523 0 01.728-.128c.204.144.421.27.65.376a.523.523 0 01-.443.947 5.343 5.343 0 01-.807-.467.523.523 0 01-.128-.728z"}}),_c('path',{attrs:{"d":"M6 3.064c.289 0 .523.234.523.523V6.08l1.32.66a.523.523 0 11-.468.935L5.766 6.87a.523.523 0 01-.289-.468V3.587c0-.289.234-.523.523-.523z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_24974_2448"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h12v12H0z"}})])])])
          )
        }
      }
    